<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ $t('configurations.link_dir') }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 overflow-x-hidden" ref="containerSelect" :style="{ 'height': heightContainerSelect }">
        <el-form ref="ruleForm" :model="form" :rules="rules">
          <div class="lg:mb-2">
            <div ref="selectPGERef">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('companies.configuration_rec.pge') }}</label>
              <el-form-item prop="pge">
                <base-el-select class="w-full" :options="pges" v-model="form.pge" clearable />
              </el-form-item>
            </div>
          </div>
          <div class="lg:mb-2">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ this.form.pge === 'FACE' ? $t('companies.configuration_rec.dir3') : $t('companies.configuration_rec.dire') }}</label>
              <el-form-item prop="dirName">
                <el-input class="w-full" v-model="form.dirName" type="text"></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div class="flex-none flex items-center justify-between space-x-2 px-4 bg-white py-2 mt-auto dark:bg-darkblue-900">
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" :loading="!isLoadedData"
          :disabled="!isLoadedData" />
        <base-button 
          mode="secondary-phantom-blue" 
          class="w-full" 
          :text="$t('app.apply')" 
          @click="apply" 
          :loading="!isLoadedData"
          :disabled="!isLoadedData" />
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import { i18n } from '@/i18n'

export default
{
  name: 'cif-link-dirs-dialog',
  components: {
    BaseDialogButton
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    cifEmpresaId: {
      type: [Number, String],
      default: -1
    },
    cifEmpresaCif: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {  
        dirName: '',
        pge: '',
        test: 1
      },
      isLoadedData: false
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      if (value) {
        this.form.pge = this.pges[0].id
        this.form.dirName = ''
      }
    },
  },
  mounted: async function () {
    this.isLoadedData = false
    this.form.pge = this.pges[0].id
    this.isLoadedData = true
  },
  computed: {
    pges: function () {
      return this.$store.getters['config/TIPOS_PGE_RECEPCION'].filter(x => !['OCR', 'OCRIA', 'FILES', 'AUTOFACTURA', 'MANUAL', 'EDASINVOIZE'].includes(x.id))
    },
    isEmptyList: function () {
      return this.pges === undefined || this.pges === null || this.pges.length === 0
    },
    heightContainerSelect: function () {
      return 'auto'
      // if (this.heightSelect !== undefined && this.heightSelect !== 0) {
      //   let heightCalc = this.heightSelect + this.heightInput + 30
      //   if (heightCalc > 400) heightCalc = 400
      //   return heightCalc + 'px'
      // } else {
      //   return 'auto'
      // }
    },
    direPrefix: function () {
      return this.$store.getters['config/DIRE_PREFIX']
    },
    direPrefixNames: function () {
      return this.direPrefix.map(prefix => prefix.name)
    },
    isDirNameValid: function () {
      if (this.form.pge || this.form.dirName) {
        if (this.form.pge === 'FACEB2B') {
          return (this.form.dirName.length >= 15 && this.form.dirName.length <= 20) && this.direPrefixNames.map(prefix => prefix + this.cifEmpresaCif).some(value => this.form.dirName.startsWith(value))
        }
        if (this.form.pge === 'FACE') {
          return this.form.dirName.length === 9
        }
        return true
      }
      return false
    },
    dirNameMsg: function () {
      if (!this.form.dirName) {
        return i18n.t('validation.complete')
      }
      if (this.form.pge === 'FACEB2B') {
        if (!(this.form.dirName.length >= 15 && this.form.dirName.length <= 20)) {
          return i18n.t('validation.dirslink.faceb2b.length')
        } else if (!this.direPrefixNames.some(value => this.form.dirName.startsWith(value))) {
          return i18n.t('validation.dirslink.faceb2b.wrong_dire_prefix', { countryList: this.direPrefix.map(x => `${x.country} (${x.name})`).join(', ') })
        } else if (!this.direPrefixNames.map(prefix => prefix + this.cifEmpresaCif).some(value => this.form.dirName.startsWith(value))) {
          return i18n.t('validation.dirslink.faceb2b.wrong_cif')
        }
        return i18n.t('validation.dirslink.faceb2b.wrong_cif')
      }
      if (this.form.pge === 'FACE') {
        return i18n.t('validation.dirslink.face')
      }
      return i18n.t('validation.dirslink.generic')
    },
    rules: function () { 
      return {
        pge: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.form.pge) {
                callback(new Error(i18n.t('validation.complete')))
              } else {
                callback()
              }
            }
          }
        ],
        dirName: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.form.dirName) {
                callback(new Error(i18n.t('validation.complete')))
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            message: this.dirNameMsg,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.isDirNameValid) {
                callback(new Error(this.dirNameMsg))
              } else {
                callback()
              }
            }
          }
        ]
      }
    }
  },
  methods: {
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectPGERef.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.pge = this.pges[0].id
      this.form.dirName = ''
    },
    apply: function () {
      this.$store.commit('setIsLoading', true)
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          this.isOpen = !this.isOpen
          this.$emit('applyDialog', [{ IdCIFEmpresa: this.cifEmpresaId, PGE: this.form.pge, DIR: this.form.dirName }])
          this.form.pge = this.pges[0].id
          this.form.dirName = ''
        } else {
          this.doFeedback(this.dirNameMsg)
        }
      })
      this.$store.commit('setIsLoading', false)
    }
  }
}
</script>

<style lang="scss" scoped></style>
